import { ReactComponent as ArchTarget } from '../../assets/icons/arch-target.svg';
import styles from './index.module.css'
import React, {  useState, useEffect } from 'react'
import useBreadcrumb from '../../hooks/useBreadcrumb';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { BreadcrumbContext } from '../../components/Breadcrumb';
import {
  Box,
  Button,
  Stack,
  Typography,
  Card,
  CardContent,
  CardActions,
  CardMedia,
  Grid,
} from "@mui/material";
import MedicalTourism from "../../assets/images/Medical-Tourism.jpg"
import InfusionImg from "../../assets/images/Infusion.jpg"
import ComingSoonImg from "../../assets/icons/Bck/commingsoon.png"
import RegenerativeMedicineImg from "../../assets/images/regenerative-medicine.jpg"
import MedicalBillingImg from "../../assets/images/medical-billing.jpg"
import ChronicCareImg from "../../assets/images/Others.jpg"
import MedicalGradeImg from "../../assets/images/medicalgradeimg.png"

function Service() {
  const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();
  const medicalTourismPoints = ["Cosmetic & Reconstructive Surgery",
    "Dentistry & Implants",
    "Fertility & IVF Treatments",
    "Wellness, Detox, and Rehabilitation Programs"
  ];

  useEffect(() => {
    setBreadcrumb({ title: "Services", links: [{ title: "Home", url: "/" }, { title: "Services", url: "/services" }] })

    return clearBreadcrumb;
  }, []);

  return (
    <Box sx={{ background: "white" }}>
      <Box className={styles.content}>
        <Stack direction="column">
          <Stack direction="row" sx={{ alignItems: "center" }}>
            <Typography sx={{ my: "1rem" }} variant="h4">
              Services
            </Typography>
          </Stack>
        </Stack>
        <Box>
          <Grid container spacing={4}>
            {[
              {
                title: "Medical Tourism",
                img: MedicalTourism,
                desc: "Explore our upcoming medical tourism services designed to bring global care closer—stay tuned for programs that combine treatment, travel, and comfort.",
                hasAccordion: true
              },
              {
                title: "Infusion Services",
                img: InfusionImg,
                desc: "Soon, we’ll be offering advanced infusion therapy services delivered at home or at convenient nearby locations to enhance care flexibility and comfort."
              },
              {
                title: "Regenerative Medicine",
                img: RegenerativeMedicineImg,
                desc: "Future-focused therapies supporting tissue repair, recovery, and personalized wellness."
              },
              {
                title: "Medical Billing",
                img: MedicalBillingImg,
                desc: "Comprehensive billing, claims, and insurance coordination simplifying your financial process."
              }
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card
                  sx={{
                    height: "490px",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    transition: "0.3s",
                    "&:hover": { boxShadow: "0px 0px 6px #0a9a73" }
                  }}
                >
                  <CardMedia component="img" sx={{ height: 250 }} src={item.img} />
                  <CardContent>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="h5">{item.title}</Typography>
                      <img src={ComingSoonImg} alt="Coming Soon" style={{ maxWidth: 100, minWidth: 50 }} />
                    </Stack>
                    <Stack sx={{ maxHeight: "140px", overflow: "auto" }}>
                      <Typography sx={{ mt: 1 }}>{item.desc}</Typography>
                      {item.hasAccordion && (
                        <>
                          {(
                            <Box sx={{ mt: 1, pl: 1 }}>
                              {medicalTourismPoints.map((pt, i) => (
                                <Typography key={i} sx={{ fontSize: "0.92rem", mb: 0.5 }}>
                                  • {pt}
                                </Typography>
                              ))}
                            </Box>
                          )}
                        </>
                      )}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box className={styles.content}>
        <Stack direction="column">
          <Stack direction="row" sx={{ alignItems: "center" }}>
            <Typography sx={{ my: "1rem" }} variant="h4">
              Virtual Support Services
            </Typography>
          </Stack>
        </Stack>
        <Box >
          <Grid container spacing={4}>
            {[
              {
                title: "Chronic Care Management",
                img: ChronicCareImg,
                desc: "Ongoing virtual support for patients with long-term conditions through scheduled check-ins, medication guidance, and personalized care plans."
              },
              {
                title: "Remote Patient Monitoring",
                img: InfusionImg,
                desc: "Continuous tracking of vital signs and health metrics using connected devices, enabling early detection and timely intervention by healthcare professionals."
              },
              {
                title: "Medical Grade Tracking",
                img: MedicalGradeImg, 
                desc: "This service provides continuous, medical-grade tracking of vital cardiac signs and physiological metrics through a high-precision connected wearable. By capturing real-time data during peak physical exertion, the platform bridges the gap between daily activity and clinical oversight."
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Card sx={{ height: "480px", display: "flex", flexDirection: "column", "&:hover": { boxShadow: "0px 0px 6px #0a9a73" } }}>
                  <CardMedia component="img" sx={{ height: {xs: 310,sm: 300,md: 250 },width:"100%",objectFit:"cover" }} src={item.img} />
                  <CardContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Typography variant="h5">{item.title}</Typography>
                      {/* <img src={ComingSoonImg} alt="Coming Soon" style={{ maxWidth: 130 }} /> */}
                    </Stack>
                    <Stack sx={{ maxHeight: "150px", overflow: "auto" }}>
                    <Typography sx={{ mt: 1 }}>{item.desc}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default Service

